export type ErrorParams = Readonly<Record<string, string | number>>;

/**
 * Ожидаемая ошибка предметной области. Код сопоставлен русскому сообщению в словаре @glory/i18n,
 * параметры подставляются в текст сообщения.
 */
export class DomainError extends Error {
  override readonly name = 'DomainError';
  readonly code: string;
  readonly params: ErrorParams;

  constructor(code: string, params: ErrorParams = {}, options?: ErrorOptions) {
    super(code, options);
    this.code = code;
    this.params = params;
  }
}

export function isDomainError(value: unknown): value is DomainError {
  return value instanceof DomainError;
}
